import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { LLCFunctions } from '@functions/llc.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Revoke } from '@state/llc/llc.actions';
import { ConnectedUser } from '@state/llc/llc.model';
import { LlcState } from '@state/llc/llc.state';
import LogRocket from 'logrocket';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { LLCLoginComponent } from './login/login.component';

enum ACTIONS {
	REVOKE = 'revoke',
}

enum COLUMNS {
	ACTION = 'action',
	INITIALS = 'initials',
	NAME = 'name',
	STATUS = 'status',
}

interface RowAction {
	action: ACTIONS;
	id: string;
}

@UntilDestroy()
@Component({
	selector: 'app-llc',
	templateUrl: './llc.component.html',
	styleUrls: ['./llc.component.scss'],
	standalone: false,
})
export class LlcIntegrationComponent implements OnInit {
	ACTIONS = ACTIONS;
	COLUMNS = COLUMNS;
	displayedColumns: COLUMNS[] = [
		COLUMNS.INITIALS,
		COLUMNS.NAME,
		COLUMNS.STATUS,
		COLUMNS.ACTION,
	];
	ICON = ICON;
	@Input() fct = false;
	@Input() benefits: string[] = [
		'Digitize mortgage instructions received from TD, Scotiabank and MMS lenders',
		'Streamline communications with your lenders',
		'Save time and reduce errors by automatically populating Closer with mortgage details right from LLC',
	];

	@Select(LlcState.connectedUsers) connectedUsers$!: Observable<
		ConnectedUser[]
	>;
	@Select(LlcState.isUserConnectedThemself)
	isUserConnectedThemself$!: Observable<boolean>;
	@Select(LlcState.loading) loading$!: Observable<boolean>;

	profileUrl$!: Observable<string>;

	constructor(
		private navService: NavigationService,
		private llcFunctions: LLCFunctions,
		private store: Store,
		private matDialog: MatDialog,
	) {}

	rowActionClick(action: RowAction) {
		switch (action?.action) {
			case ACTIONS.REVOKE:
				this.store.dispatch(new Revoke(action.id));
		}
	}

	ngOnInit(): void {
		this.profileUrl$ = this.isUserConnectedThemself$.pipe(
			switchMap((connected) => {
				if (connected) {
					return this.llcFunctions
						.getRedirectUrl('USERPROFILE')
						.pipe(map((url) => url.url));
				}

				return of('');
			}),
			catchError((err) => {
				LogRocket.log('Error fetching llc profile url', err);
				console.log('Error fetching url');

				return of('');
			}),
		);
	}

	connect() {
		const config = this.fct
			? LlcState.fctDialogConfig
			: LlcState.llcDialogConfig;
		this.matDialog.open(LLCLoginComponent, config);
	}
}
